import { ICoast } from "@/@types/_shared/coast";
import { ICurrency } from "@/@types/currency";
import stroe from "@/store";

export function resolveCurrencySymbol(ref: string): string {
  if (!ref) return "";
  const currencys: Array<ICurrency> = stroe.getters.getCurensy || [];
  for (const c of currencys) {
    if (c.unicodeSymbol && c.unicodeSymbol === ref) return ref;
  }
  const found = currencys.find((c) => c._id === ref);
  if (found && found.unicodeSymbol) return found.unicodeSymbol;
  return ref;
}

export function getCoast(coast: Array<ICoast>): ICoast {
  const currencys: Array<ICurrency> = stroe.getters.getCurensy || [];
  const defaultCurency = currencys[0];
  const defaultId = defaultCurency ? defaultCurency._id : "";
  const defaultSymbol = defaultCurency ? defaultCurency.unicodeSymbol : "";

  const empty: ICoast = { value: 0, currency: "" };
  if (!coast.length) return empty;
  for (const c of coast) {
    if (!c) continue;
    if (!c.currency || !c.value) return empty;
    if (c.currency === defaultId || c.currency === defaultSymbol) {
      return {
        currency: defaultSymbol,
        value: c.value ? c.value : 0,
      };
    }
  }

  const first = coast[0];
  return {
    currency: resolveCurrencySymbol(first.currency ? first.currency : ""),
    value: first.value ? first.value : 0,
  };
}
